export default {
  telemetryEntries: (state) => state.telemetryEntries,
  loading: (state) => state.loading,
  page: (state) => state.page,
  sortBy: (state) => state.sortBy,
  orderBy: (state) => state.orderBy,
  search: (state) => state.search,
};
